// extracted by mini-css-extract-plugin
module.exports = {"elSection":"Section_elSection__3N6l4","warningModal":"Section_warningModal__149TP"};